import React from 'react';
import PropTypes from 'prop-types';
import styles from './ButtonNew.scss';

const ButtonNew = ({
					name = Math.random().toString(36).substring(7),
					value,
					type = 'button',
					onClick,
					className = '',
					classNameConcat = '',
					disabled,
					ariaLabel,
					title,
					id,
					testId,
					analyticsType,
					analyticsPositionIndex,
					analyticsText,
  					formNoValidate
				}) => {
	let classNameInner = (className === '') ? styles.btnBlack : className;

	if (classNameConcat) {
		classNameInner += ` ${classNameConcat}`;
	}

	if (!analyticsText) {
		analyticsText = value;
	}

	return (
	  <input
		type={type}
		name={name}
		value={value}
		onClick={onClick}
		className={`${classNameInner}`}
		id={id}
		disabled={disabled}
		title={title}
		data-test={testId}
		aria-label={ariaLabel}
		data-elements-text={analyticsText}
		data-elements-content={analyticsType}
		data-elements-position={analyticsPositionIndex}
		formNoValidate={formNoValidate}
	  />
	);
};

ButtonNew.propTypes = {
	name: PropTypes.string,
	onClick: PropTypes.func,
	value: PropTypes.string,
	type: PropTypes.string,
	className: PropTypes.string,
	classNameConcat: PropTypes.string,
	id: PropTypes.string,
	testId: PropTypes.string,
	ariaLabel: PropTypes.string,
	title: PropTypes.string,
	disabled: PropTypes.bool,
	analyticsText: PropTypes.string,
	analyticsPositionIndex: PropTypes.number,
	analyticsType: PropTypes.string,
	formNoValidate: PropTypes.bool
};

export default ButtonNew;
export {styles as buttonStyles};
